import { useAuthStore } from '@/store/auth';
import { Button, FormField, RadioGroup, RadioGroupItem } from '@opaz/ui-components';
import { useMemo } from 'react';
import { useController, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface ResidencyStatusInput {
  isResident: boolean | undefined;
}

type ResidencyStatusFormProps = {
  data: ResidencyStatusInput;
  onComplete: (data: ResidencyStatusInput) => void;
};

export const ResidencyStatusForm = ({ data, onComplete }: ResidencyStatusFormProps) => {
  const { t, i18n } = useTranslation();
  const { authService } = useAuthStore();
  const { handleSubmit, control } = useForm<ResidencyStatusInput>({
    defaultValues: data,
  });

  const { field: isResidentField } = useController({
    control,
    name: 'isResident',
  });

  // TODO: Remove the isPkiLoginV2 check when the new pki login is released
  const isPkiLoginV2 = useMemo(() => {
    return localStorage.getItem('pkiLogin') === 'v2';
  }, []);

  const onSubmit = async (formData: ResidencyStatusInput) => {
    if (formData.isResident === true && isPkiLoginV2) {
      await authService?.signinRedirect('theqa');
      return;
    }
    onComplete(formData);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-10">
        <h1 className="font-bold text-3xl text-[#1A444F] mb-6">{t('register.residencyStatusTitle')}</h1>
        <p className="text-xl text-muted-foreground">{t('register.residencyStatusDescription')}</p>
      </div>

      <FormField>
        <RadioGroup
          dir={i18n.dir()}
          value={isResidentField.value?.toString()}
          onValueChange={(value) => {
            isResidentField.onChange(value === 'true');
          }}
        >
          <RadioGroupItem value="true">{t('common.yes')}</RadioGroupItem>

          <RadioGroupItem value="false">{t('common.no')}</RadioGroupItem>
        </RadioGroup>
      </FormField>

      <Button className="w-full mt-8" type="submit" disabled={isResidentField.value === undefined}>
        {t('register.actionButtonLabel')}
      </Button>
    </form>
  );
};
